<template>
  <v-container>
    <alerts
      module="cart"
    />

    <product-items-loading v-if="loading" />

    <v-data-iterator
      v-else
      :items="products"
      itemKey="name"
      :itemsPerPage="20"
      hideDefaultFooter
    >
      <template v-slot:default="{ items }">
        <v-row>
          <v-col
            v-for="item in items"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            :key="item.id"
          >
            <v-card>
              <product-image class="cursor-pointer" :product="item" @click.native="() => goToDetails(item)" />
              <v-card-title class="text-wrap">{{ item.title }}</v-card-title>
              <v-card-actions>
                <product-price :product="item" />
                <span v-if="!isAvailable(item)" class="subtitle red--text ml-2">Out of Stock</span>
                <v-spacer />
                <v-btn
                  :disabled="!isAvailable(item)"
                  outlined
                  color="green"
                  @click="addToCart(item)"
                >
                  <v-icon>mdi-cart-plus</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-dialog v-model="showVariantDialog" maxWidth="500px" @click:outside="closeVariantDialog">
      <v-card>
        <v-card-title v-if="selectedProduct">{{ selectedProduct.title }}</v-card-title>
        <v-card-subtitle>Select Product Variation</v-card-subtitle>
        <v-card-text>
          <product-selection v-model="selectedVariation" :product="selectedProduct" ref="productSelection" />
          <span v-if="selectedVariation && !selectedVariation.available" class="subtitle red--text d-flex justify-end">Out of Stock</span>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeVariantDialog">Cancel</v-btn>
          <v-spacer />
          <v-btn color="success" :disabled="!selectedVariation || !selectedVariation.available" @click="addVariantToCart">
            <v-icon>mdi-cart-plus</v-icon>
            Add to Cart
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import ProductImage from '@/components/utilities/productImage.vue';
import ProductPrice from '@/components/utilities/productPrice.vue';
import ProductSelection from './utilities/productSelection.vue';
import ProductItemsLoading from './utilities/productItemsLoading.vue';

export default {
  name: 'TheProducts',
  components: {
    ProductImage,
    ProductPrice,
    ProductSelection,
    ProductItemsLoading
  },
  data: function () {
    return {
      products: [],
      showVariantDialog: false,
      selectedProduct: null,
      selectedVariation: null,
      loading: false
    };
  },
  methods: {
    addVariantToCart: function () {
      if (this.selectedVariation) {
        const lineItemsToAdd = [
          {
            variantId: this.selectedVariation.id,
            quantity: 1
          }
        ];
        this.$store.dispatch('cart/addItem', lineItemsToAdd);
        this.closeVariantDialog();
      }
    },
    addToCart: function (item) {
      if (item.variants.length > 1) {
        this.showVariantDialog = true;
        this.selectedProduct = item;
        if (this.$refs.productSelection) {
          this.$refs.productSelection.setInitialVariant(item);
        }
      } else {
        const lineItemsToAdd = [
          {
            variantId: item.variants[0].id,
            quantity: 1
          }
        ];
        this.$store.dispatch('cart/addItem', lineItemsToAdd);
      }
    },
    closeVariantDialog: function () {
      this.showVariantDialog = false;
      this.selectedVariation = null;
      this.selectedProduct = null;
      this.$refs.productSelection.resetDefaults();
    },
    getProducts: function () {
      this.loading = true;
      // Fetch all products in your shop
      this.$shopify.product.fetchQuery({
        sortKey: 'ID',
        query: '-product_type:\'Menu\''
      }).then((products) => {
        // Do something with the products
        this.products = products;
        this.loading = false;
      });
    },
    goToDetails: function (selectedProduct) {
      this.$router.push({
        name: 'productDetails',
        params: {
          id: selectedProduct.id
        }
      });
    },
    isAvailable: function (product) {
      for (const variant of product.variants) {
        if (variant.available) {
          return true;
        }
      }
      return false;
    }
  },
  created: function () {
    this.getProducts();
  }
};
</script>
